<template>
  <div>
    <div class="device-mobile" v-if="isMobile">
      <div class="cms-section">
        <div class="navigation">
          <div class="navigationItem">
            <img src="../../assets/home.png" alt="" @dragstart.prevent>
            <span @click="$emit('home')">{{ $t('nav.home') }}</span>
            <span class="arrow">></span>
            <span @click="$emit('section-click')">{{ sectionTitle }}</span>
            <span class="arrow">></span>
            <span v-if="activeMenuName">{{ activeMenuName }}</span>
          </div>
        </div>
        <div class="tabbar">
          <div
            v-for="(item, index) in menuList"
            :key="item.menuId"
            class="item"
            :class="{ active: String(activeMenuId) === String(item.menuId) }"
            @click="$emit('menu-click', index, item)"
          >
            <div class="txt">{{ item.menuName }}</div>
            <div class="line"></div>
          </div>
        </div>
        <div class="card">
          <slot name="mobile-content" />
        </div>
      </div>
    </div>
    <div class="device-pc" v-else>
      <div class="cms-section">
        <div class="navigation">
          <div class="navigationItem">
            <img src="../../assets/home.png" alt="" @dragstart.prevent>
            <span @click="$emit('home')" style="cursor: pointer;">{{ $t('nav.home') }}</span>
            <span style="color: black;">></span>
            <span @click="$emit('section-click')">{{ sectionTitle }}</span>
            <span style="color: black;">></span>
            <span v-if="activeMenuName">{{ activeMenuName }}</span>
          </div>
        </div>
        <div class="main">
          <div class="left">
            <div class="top">{{ sectionTitle }}</div>
            <div
              v-for="(item, index) in menuList"
              :key="item.menuId"
              class="bar"
              :class="{ bar1: String(activeMenuId) === String(item.menuId) }"
              @click="$emit('menu-click', index, item)"
            >
              {{ item.menuName }}
            </div>
          </div>
          <slot name="pc-content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CmsSectionShell',
  props: {
    sectionTitle: { type: String, default: '' },
    menuList: { type: Array, default: () => [] },
    activeMenuId: { type: [String, Number], default: '' },
    activeMenuName: { type: String, default: '' },
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
}
</script>

<style scoped lang="scss">
.device-mobile {
  .cms-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 9.466667rem;
    margin-bottom: 1.466667rem;

    .navigation {
      width: 100%;
      padding: 0 0.333333rem;

      .navigationItem {
        display: flex;
        align-items: center;
        padding-top: 0.36rem;
        color: #1979b7;
        font-size: 0.333333rem;

        .arrow {
          color: #030303;
          margin: 0 0.133333rem;
        }

        img {
          width: 0.333333rem;
          height: 0.333333rem;
          margin-right: 0.133333rem;
        }
      }
    }

    .tabbar {
      width: 100%;
      height: 1.653333rem;
      display: flex;
      align-items: center;

      .item {
        position: relative;
        display: flex;
        flex-direction: column;
        margin-right: 0.4rem;

        &.active {
          .txt {
            font-size: 0.453333rem;
            font-weight: bold;
            color: #000000;
          }

          .line {
            display: block;
          }
        }

        .txt {
          font-size: 0.4rem;
          font-weight: 400;
          color: #000000;
        }

        .line {
          position: absolute;
          bottom: -0.266667rem;
          display: none;
          margin-top: 0.213333rem;
          width: 1.2rem;
          height: 0.053333rem;
          background: #007cc3;
        }
      }
    }

    .card {
      width: 100%;
      box-shadow: 0 0 0.32rem rgba(0, 0, 0, 0.1);
    }
  }
}

.device-pc {
  .cms-section {
    width: 100vw;
    background: #F5F5F5;
    padding-bottom: 50px;
  }

  .navigation {
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;

    .navigationItem {
      width: 1300px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      height: 36px;
      line-height: 36px;
      margin-bottom: 20px;
      padding-top: 15px;
      box-sizing: border-box;
      color: #1979b7;
      font-size: 20px;
    }

    img {
      width: 20px;
      height: 20px;
      margin-right: 7px;
    }
  }

  .main {
    display: flex;
    margin: 0 auto;
    width: 1300px;
    padding-top: 25px;
  }

  .left {
    .top {
      width: 270px;
      height: 64px;
      background: url('../../assets/bannerImg.png') no-repeat;
      background-size: 100%;
      font-size: 26px;
      font-weight: bold;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .bar {
      width: 270px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      font-size: 18px;
      color: #333333;
      cursor: pointer;
      background: #fff;
      border-bottom: 1px solid #ededed;
      box-sizing: border-box;
    }

    .bar1 {
      color: #0175c2;
      font-weight: bold;
      border-bottom: 1px solid #0175c2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cms/CmsSectionShell.vue